import { Button, Box } from "@mui/material";
import { Link as RouterLink } from 'react-router-dom';
import { route } from '/@/app/routes';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useTranslation } from 'react-i18next';


//
// User-familiar button to point user to the next step.
// In Future - can be used together with UserFlowState, w/o arguments.
//
export const NextStepButton = ({ to }) => {
const { t } = useTranslation();
    return (
        <Box sx={{ textAlign: "center", mt: 4 }}>
            <Button
                component={RouterLink}
                to={route(to)}
                variant="contained"
            >{t("К следующему шагу")} <NavigateNextIcon/></Button>
        </Box>
    );
}
